import type { ReactElement } from 'react';
import { Icon } from '../icon/index.js';
import type { PlaceholderProps } from './types.js';
import { Placeholder as _Placeholder } from '#~/common/card/index.js';

/** Audio `<Placeholder>` component. */
export const Placeholder = (props: PlaceholderProps): ReactElement => (
  <_Placeholder icon={<Icon />} title='Add an audio source' {...props} />
);
